/**
 * Jamaica's 14 parishes - used for search autocomplete and filtering.
 * Format matches MLS data.region (district) for consistency.
 */
export const JAMAICA_PARISHES = [
  'Clarendon',
  'Hanover',
  'Kingston',
  'Manchester',
  'Portland',
  'St. Andrew',
  'St. Ann',
  'St. Catherine',
  'St. Elizabeth',
  'St. James',
  'St. Mary',
  'St. Thomas',
  'Trelawny',
  'Westmoreland',
];

/** Parish slug for URL (e.g. st-andrew, st-catherine) */
export const parishToSlug = (parish) =>
  parish
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/\./g, '')
    .replace('st-', 'saint-');

// Keep the existing Kingston route/filter key while making its wider scope clear.
export const parishSearchLabel = (parish) =>
  parish === 'Kingston' ? 'Kingston & St. Andrew' : parish;
